'use strict';

import { register } from '../../../JavaScript/Utils';

const pad2 = value => String(value).padStart(2, '0');

const updateTimer = (el) => {
    const expirySeconds = parseInt(el.dataset.expiry, 10);
    if (!expirySeconds || Number.isNaN(expirySeconds)) {
        el.style.display = 'none';
        return false;
    }

    const diffMs = (expirySeconds * 1000) - Date.now();
    if (diffMs <= 0) {
        el.style.display = 'none';
        return false;
    }

    const diffSeconds = Math.floor(diffMs / 1000);
    const days = Math.floor(diffSeconds / 86400);
    const hours = Math.floor((diffSeconds % 86400) / 3600);
    const minutes = Math.floor((diffSeconds % 3600) / 60);
    const seconds = diffSeconds % 60;

    const daysEl = el.querySelector('[data-unit="days"]');
    const hoursEl = el.querySelector('[data-unit="hours"]');
    const minutesEl = el.querySelector('[data-unit="minutes"]');
    const secondsEl = el.querySelector('[data-unit="seconds"]');

    if (daysEl) daysEl.textContent = String(days);
    if (hoursEl) hoursEl.textContent = pad2(hours);
    if (minutesEl) minutesEl.textContent = pad2(minutes);
    if (secondsEl) secondsEl.textContent = pad2(seconds);

    return true;
};

const applyLabelMode = (el) => {
    const mode = el.dataset.labelMode || 'full';
    if (mode !== 'short') return;

    const labelEls = el.querySelectorAll('[data-unit-label]');
    labelEls.forEach(labelEl => {
        const text = labelEl.textContent || '';
        labelEl.textContent = text.trim().charAt(0);
    });
};

const initPromotionTimer = (el) => {
    applyLabelMode(el);
    if (!updateTimer(el)) return;

    const interval = setInterval(() => {
        const stillActive = updateTimer(el);
        if (!stillActive) {
            clearInterval(interval);
        }
    }, 1000);
};

register('PromotionTimer', initPromotionTimer);
